module.exports = "./img/e62bcfc615f5e10870e531df7198b714.jpg";